export const FETCH_COMPANIES_SUCCESS = "FETCH_COMPANIES_SUCCESS";
export const SET_COMPANIES_FIELD = "SET_COMPANIES_FIELD";
export const SET_NUMBER_OF_USERS_FOR_COMPANY = "SET_NUMBER_OF_USERS_FOR_COMPANY";
export const SET_COMPANY_DELETE_DIALOG_LOADING = "SET_COMPANY_DELETE_DIALOG_LOADING";
export const FETCH_COMPANIES_FOR_SELECT = "FETCH_COMPANIES_FOR_SELECT";
